<div class="modal-header">
    <h4 class="modal-title">LogIn</h4>
    <button type="button" class="close" aria-label="Close" (click)="broadcastEvent('Close')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">    
    <div id="exampleInputGroup1" role="group"class="form-group">
      <div>
        <input id="exampleInput1" type="email" placeholder="Enter Email" required="required"
                  aria-required="true" class="form-control">
      </div>
    </div>
    <div id="exampleInputGroup2" role="group" class="form-group">
      <div><input id="exampleInput2" type="password" placeholder="Enter Password" required="required"
                  aria-required="true" class="form-control"></div>
    </div>     
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="broadcastEvent('Close')">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="login()">LogIn</button>
  </div>